(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name debugService
     *@description
     *Servicio que hace debug
     */

    angular
        .module('app')
        .factory('debugService', debugService);

    debugService.$inject = ["$log"];

    function debugService($log) {

        var debug = {
            enabled: true,
            info: []
        };

        debug.log = function(msg)
        {
        	if(debug.enabled)
        		$log.log(msg);
        };

        debug.info = function(msg)
        {
        	if(debug.enabled)
        		$log.info(msg);
        };

        debug.warn = function(msg)
        {
        	if(debug.enabled)
        		$log.warn(msg);
        };		

		debug.error = function(msg)
		{
			if(debug.enabled)
        		$log.error(msg);

		};

		debug.debug = function(msg)
		{
			if(debug.enabled)
        		$log.debug(msg);

		};

        debug.add = function(e) {
        	e.id=guid();
        	e.created =  new Date().getTime();
            if(!e.format)
                e.format='json';
            debug.info.push(e);
        };

        debug.delete = function() {

        };


        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
        }

        return debug;


    }



})();
